import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import { CommonParamInput } from 'common/repositories/common.model';

export class BalanceAdjustmentLiteModel {
  id: string;
  number: string;
  type: string;
  description: string;

  @Type(() => Date)
  date: Date;

  @Expose({ name: 'balanceable_type' })
  balanceableType: string;

  @Expose({ name: 'balanceable_name' })
  balanceableName: string;

  @Type(() => Number)
  balance: number;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export enum BalanceAdjustmentUserTypeEnum {
  customer = 'Customer',
  agent = 'Agent',
}

export class BalanceModel {
  id: string;
  name: string;
  address: string;
  alias: string;
  title: string;
}

export enum BalanceAdjusmentTypeEnum {
  add = 'add',
  substract = 'subtract',
}

export class BalanceAdjustmentModel {
  id: string;
  description: string;
  type: string;
  number: string;
  status: TransactionalStatusEnum;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Type(() => Date)
  date: Date;

  @Expose({ name: 'balanceable_type' })
  balanceableType: string;

  @Type(() => BalanceModel)
  balanceable: BalanceModel;

  @Type(() => Number)
  amount: number;

  @Type(() => Number)
  balance: number;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class getBalanceAdjustmentsInput {
  params: CommonParamInput;
}

export class getBalanceAdjustmentInput {
  id: string;
}

export class BalanceAdjustmentMutationInput {
  date: Date;
  needApproval: boolean;
  balanceableId: string;
  type: string;
  amount: number;
  description: string;
}

export class BalanceAdjustmentUpdateInput {
  balanceAdjustmentId: string;
  body: BalanceAdjustmentMutationInput;
}

export class BalanceAdjustmentDeleteInput {
  balanceAdjustmentId: string;
}
